import { isCarryonpanTossHost } from './toss-origin';
import { Capacitor } from '@capacitor/core';

export type Channel = 'web' | 'apps_in_toss' | 'ios' | 'android';

export interface PlatformAdapter {
  channel: Channel;
  native: boolean;
  lightOnly: boolean;
  shareFile(file: File): Promise<'shared' | 'downloaded'>;
  haptic(kind: 'light' | 'success'): void;
}

function downloadFile(file: File) {
  const url = URL.createObjectURL(file);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = file.name;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1_000);
}

function currentChannel(): Channel {
  const nativePlatform = Capacitor.getPlatform();
  if (nativePlatform === 'ios' || nativePlatform === 'android') return nativePlatform;
  return isCarryonpanTossHost(location.hostname) || (import.meta.env.MODE === 'toss' && ['localhost', '127.0.0.1'].includes(location.hostname)) ? 'apps_in_toss' : 'web';
}

const channel = currentChannel();

export const platform: PlatformAdapter = {
  channel,
  native: channel === 'ios' || channel === 'android',
  lightOnly: channel === 'apps_in_toss',
  async shareFile(file) {
    if(channel==='apps_in_toss') {
      const { File: TossFile } = await import('@apps-in-toss/web-framework');
      if(!TossFile.saveBase64.isSupported()) throw new Error('이 토스 버전에서는 파일 저장을 지원하지 않아요.');
      const bytes=new Uint8Array(await file.arrayBuffer());let binary='';
      for(let offset=0;offset<bytes.length;offset+=0x8000)binary+=String.fromCharCode(...bytes.subarray(offset,offset+0x8000));
      await TossFile.saveBase64({data:btoa(binary),fileName:file.name,mimeType:file.type});
      return 'downloaded';
    }
    if (navigator.maxTouchPoints > 0 && navigator.share && navigator.canShare?.({ files: [file] })) {
      await navigator.share({ title: '캐리온판 여행 준비 자료', files: [file] });
      return 'shared';
    }
    downloadFile(file);
    return 'downloaded';
  },
  haptic(kind) {
    if ('vibrate' in navigator) navigator.vibrate(kind === 'success' ? [20, 30, 40] : 15);
  },
};
